module.exports = __webpack_public_path__ + "img/check-circle-orange.c5a56d55.svg";